module.exports = __webpack_public_path__ + "static/1-13de830f842a067da442bf7f74ed8680.jpg";